import * as React from 'react';
import { connect } from 'react-redux';

import { IMainPage } from '../../models/mainpage';
import { ITopJK } from '../../models/top_three';
import { TopJK } from '../../components/top_three/top_jk';
import { IRegionsData } from '../../models/regions_data';

import { trackPopular } from '../../helpers/metrics_helper';

interface IProps {
  services?: React.ReactNode;
  popularJks: ITopJK[] | null;
  allJKLink?: string;
  regionsData: IRegionsData;
}

interface IPopularProps {
  services?: React.ReactNode;
}

class PopularList extends React.Component<IProps> {

  public render() {
    const top = this.props.popularJks;

    if (top && top.length < 3) {
      if (this.props.services) {
        return this.props.services;
      } else {
        return (<div />);
      }
    }
    return (
      <TopJK
          onPromoClick={(eventLabel: string) => trackPopular(eventLabel)}
          services={this.props.services}
          offers={top || []}
          locationName={this.props.regionsData.subdomainRegionAllowed ?
            this.props.regionsData.subdomainRegionInflectedTitleLoct :
            'в Москве'
          }
          allJkLink={this.props.allJKLink}/>
    );
  }
}

const PopularListWrapper = connect<{}, {}, any>((
    state: { mainpage: IMainPage },
    props: IPopularProps) => ({
  popularJks: state.mainpage.popularJks,
  isFetching: state.mainpage.isFetching,
  allJKLink: state.mainpage.urls.jks,
  regionsData: state.mainpage.regionsData,
  services: props.services,
}))(PopularList);

export { PopularListWrapper as JKPopularList, PopularList as JKPopularListClass };
